import AuthContext from "../../../../auth/AuthContext";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AssessmentService from '../../../../services/AssessmentService';
import AlertService from '../../../../services/AlertService';
import { Button } from "react-bootstrap";

const ConfirmAssessment = () => {
    const navigate = useNavigate();
    const { type, assessmentName } = useParams();
    const { state } = useLocation();
    const authContext = useContext(AuthContext);
    const [courseName, setCourseName] = useState();
    const assessmentId = state?.id || sessionStorage.getItem("assessmentId");
    
const loadAssessment = useCallback(async (signal) => { 
    try {
      const data = await AssessmentService.GetInfo(
        assessmentId,
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setCourseName(data.data.title);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    }
  }, [authContext, assessmentId]);

useEffect(() => {
    const controller = new AbortController(); 
    if (assessmentId) {
      loadAssessment(controller.signal); 
    }
    return () => controller.abort(); 
  }, [loadAssessment, authContext, assessmentId]);

    const onStartExam = async () => {
        authContext.setOnGoingValidations(true);
        navigate(`/assessments/${assessmentName}/start-${type}`, { state: { id: assessmentId } });
    };

    return (
        <Fragment>
            <div className="container-fluid custom-container mt-3">
                <div className="d-flex">
                    <div style={{ color: '#1A7EC0' }}>Course Name :</div>
                    <div className="ms-1">{courseName}</div>
                </div>
                <div className="col-12 pt-2">
                    <div className="instructions pt-2">
                        <span>Welcome to the assessment. Please read the following instructions carefully</span>
                        <ol type="1">
                            <li className="pt-2">
                                <b>Timing:</b>
                                <ol type="I">
                                    <li>The timer will start as soon as you enter the assessment.</li>
                                    <li>
                                        If you leave the assessment, the timer will pause, and it will resume
                                        when you re-enter.
                                    </li>
                                    <li>
                                        Once the total time is used up, the assessment will end, and you will no
                                        longer be able to take it again.
                                    </li>
                                </ol>
                            </li>
                            <li className="pt-2">
                                <b>Answering Questions:</b>
                                <ol type="I">
                                    <li>
                                        For each question, select the most appropriate answer from the
                                        multiple-choice options provided.
                                    </li>
                                    <li>
                                        You can indicate your confidence level by clicking the Confident Box for
                                        each question.
                                    </li>
                                    <li>
                                        If you skip or miss a question, it will count as 0 points for both your
                                        original and confidence scores.
                                    </li>
                                </ol>
                            </li>
                            <li className="pt-2">
                                <b>Auto-Submission:</b>
                                <ol type="I">
                                    <li>
                                        When the time limit is reached, the assessment will automatically stop
                                        accepting inputs. Only the "Submit" button will remain enabled, allowing
                                        you to submit your answers.
                                    </li>
                                </ol>
                            </li>
                            <li className="pt-2">
                                <b>Scoring:</b>
                                <ol type="I">
                                    <li>
                                        <b>Original Score:</b> Based on whether your answers are correct or
                                        incorrect.
                                    </li>
                                    <li>
                                        <b>Confident Score:</b> This will be calculated as follows:
                                        <ol type="a">
                                            <li>
                                                <b>Correct Answer + Confident:</b> +1 point
                                            </li>
                                            <li>
                                                <b>Correct Answer + Not Confident:</b> +0.5 points
                                            </li>
                                            <li>
                                                <b>Incorrect Answer + Confident:</b> -1 point
                                            </li>
                                            <li>
                                                <b>Incorrect Answer + Not Confident:</b> -0.5 points
                                            </li>
                                            <li>
                                                <b>Missed Question:</b> 0 points (for both the original and
                                                confidence scores)
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>
                            <li className="pt-2">
                                <b>Do Not Leave the Page:</b>
                                <ol type="I">
                                    <li>
                                        Once you begin the assessment, do not leave or refresh the page until
                                        you submit your answers. Leaving without submitting may result in the
                                        loss of your progress.
                                    </li>
                                </ol>
                            </li>
                            <li className="pt-2">
                                <b>Integrity:</b>
                                <ol type="I">
                                    <li>
                                        Please ensure that all answers are your own. Any form of dishonesty will
                                        result in disqualification.
                                    </li>
                                </ol>
                            </li>
                            <li className="pt-2">
                                <b>Support:</b>
                                <ol type="I">
                                    <li>
                                        If you experience any technical issues, you can raise a ticket through
                                        our <b>Support Handle Engine</b> or contact us via email at{" "}
                                        <a href="mailto:support@tevelcyber.com">support@tevelcyber.com</a>.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <div>
                            <b>
                                By starting this assessment, you agree to follow these instructions and complete
                                the task honestly.
                            </b>
                        </div>
                        <div className="pt-2">
                            <b>Good luck!</b>
                        </div>
                    </div>
                    <div className="d-flex bd-highlight">
                        <Button
                            variant="primary"
                            className="ms-auto px-4 px-md-5 py-2"
                            onClick={onStartExam}
                        >
                            Continue to Exam
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ConfirmAssessment;
